import {
  PortableText as BasePortableText,
  NodeType,
} from '@portabletext/react';
import logger from '@/utils/logger';
import Blockquote from '@/components/portableText/Blockquote';
import List from '@/components/portableText/List';
import ExternalLink from '@/components/portableText/LinkExternal';
import Typography from '@/components/portableText/Typography';
import type {
  PortableTextComponents,
  PortableTextProps,
  MissingComponentHandler,
} from '@portabletext/react';

const ptComponents: PortableTextComponents = {
  // Common list types
  // ex: common list types, checkmarks, anything custom
  list: {
    number: ({ children, value }) => (
      <List type={value.listItem}>{children}</List>
    ),
    bullet: ({ children, value }) => (
      <List type={value.listItem}>{children}</List>
    ),
  },

  // Custom components for marks
  // ex: characterReference, speech, popovers, etc.
  marks: {
    link: ExternalLink,
  },

  // Custom components for block styles
  block: {
    h1: ({ children }) => (
      <Typography variant='h1' fontWeight='bold'>
        {children}
      </Typography>
    ),
    h2: ({ children }) => (
      <Typography variant='h2' fontWeight='bold'>
        {children}
      </Typography>
    ),
    h3: ({ children }) => (
      <Typography variant='h3' fontWeight='bold'>
        {children}
      </Typography>
    ),
    h4: ({ children }) => (
      <Typography variant='h4' fontWeight='bold'>
        {children}
      </Typography>
    ),
    h5: ({ children }) => (
      <Typography variant='h5' fontWeight='bold'>
        {children}
      </Typography>
    ),
    h6: ({ children }) => (
      <Typography variant='h6' fontWeight='bold'>
        {children}
      </Typography>
    ),
    normal: ({ children }) => (
      <Typography variant='body1'>{children}</Typography>
    ),
    blockquote: ({ children }) => <Blockquote>{children}</Blockquote>,
  },
};

export const onMissingComponent: MissingComponentHandler = (
  message: string,
  options: {
    type: string;
    nodeType: NodeType;
  }
) => {
  logger.warn(message, {
    type: options.type,
    nodeType: options.nodeType, // 'block' | 'mark' | 'blockStyle' | 'listStyle' | 'listItemStyle'
  });
};

const PortableText = ({ value }: PortableTextProps) => (
  <BasePortableText
    value={value}
    components={ptComponents}
    onMissingComponent={onMissingComponent}
  />
);

export default PortableText;
